export const isPdfProxyFormat = (assetProxyFormat: string) =>
  assetProxyFormat === 'PDF';
